import { useEffect } from 'react';
import { useSearchParams, Navigate } from 'react-router-dom';
import packageJson from '../../package.json';

export const Version = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Set the content type to application/json
    document.body.style.margin = '0';
    document.body.style.padding = '0';
  }, []);

  // Check if app_chk=true parameter is present
  const appChk = searchParams.get('app_chk');

  if (appChk !== 'true') {
    // Redirect to 404 if the required parameter is not present
    return <Navigate to="/404" replace />;
  }

  const versionData = {
    v: packageJson.version,
  };

  return <pre style={{ margin: 0, padding: 0 }}>{JSON.stringify(versionData)}</pre>;
};
